import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts&setup=true"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=59b6be4d&scoped=true&css=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b6be4d"]])

export default __exports__